import InputSelect from '../InputSelect';
import { fetchCompanyCoordinates } from '../../api/WorkspaceApi';
import { useState, useContext, useEffect } from 'react';
import GlobalContext from '../../context/GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { components as rsComponents } from 'react-select';

import { tr } from "../../i18n";
const SelectCoordinate = (props) => {
    const { user } = useContext(GlobalContext);
    const [coordinates, setCoordinates] = useState([]);
    const [defaultOption,setDefaultOption] = useState(null);

    const customComponents = {
        SingleValue: (props) => (
            <rsComponents.SingleValue {...props}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginRight: 8, color: "#555" }} />
                    {props.data.label}
                </div>
            </rsComponents.SingleValue>
        ),
        Option: (props) => {
            const { data, innerRef, innerProps } = props;
            return (
                <div className='react-custom-single-value' ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center', padding: "10px" }}>
                    <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginRight: 8, color: "#555" }} />
                    {data.label}
                </div>
            );
        }
    };

    const data = {
        name: props.name,
        className: props.className,
        rules: props.rules,
        components: customComponents, // Gunakan custom components
        placeholder: props.placeholder || tr("attendance:leave_blank_for_everywhere"),
        options: coordinates,
        key: null,
        label: props.label,
        defaultValue: defaultOption,
        disabled: props.disabled,
    };

    const fetchCoordinates = async (keyword = '', defaultValue = '') => {
        try {
            const coordinateList = await fetchCompanyCoordinates(user.workspace.company_id, keyword,defaultValue);

            if(defaultValue){
                return coordinateList
            }else{
                return coordinateList.data.map((coordinate) => ({
                    label: String(coordinate.text),
                    value: String(coordinate.id),
                }));
            }

        } catch (error) {
            console.error("Error fetching coordinates", error);
            return [];
        }
    };
    
    useEffect(() => {

        const loadInitialData = async () => {
            if (props.defaultValue) {
                const defaultData = await fetchCoordinates('', props.defaultValue);

                if(defaultData.data[0]){
                    setDefaultOption(defaultData.data[0]);
                }
            }
        }

        loadInitialData();

    }, [props.defaultValue, user.workspace.company_id]);

    async function handleData(search = '') {
        const result = await fetchCoordinates(search);
        
        return result; // Pastikan ini array, bukan Promise
    }    
    

    return (
        <div className='select-container' style={{ textAlign: "left" }}>
            <InputSelect 
                data={data} 
                handleChange={() => {}} 
                handleOnLoadData={handleData}
                components={customComponents}
            />
        </div>
    );
}

export default SelectCoordinate;